import { values } from 'lodash'

const months = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre']
const trimester = ['Trimestre 1', 'Trimestre 2', 'Trimestre 3']
const semester = ['Semestre 1', 'Semestre 2']
const CATEGORIES_TICKETS = {
    ANALYSIS: 'Analyse',
    ANOMALY: 'Anomalie',
    SUPPORT: 'Assistance',
    EVOLUTION: 'Evolution',
    FORMATION: 'Formation',
    INSTALLATION: 'Installation',
    SERVICE: 'Prestation',
    SYSTEM: 'Système',
}

const URL_WANTED = 'URL_WANTED'

const PRODUCT_LIST = [
    { value: 'myliaQ', label: 'myliaQ' },
    { value: 'seQoya', label: 'seQoya' },
    { value: 'acycliQ', label: 'acycliQ' },
    { value: 'iryQua', label: 'iryQua' },
    { value: 'mantyQ', label: 'mantyQ' },
    { value: 'synaptiQ', label: 'synaptiQ' },
    { value: 'Qaptys', label: 'Qaptys' },
    { value: 'Observatoire', label: 'Observatoire' },
    { value: 'Widgets', label: 'Widgets' },
    { value: 'IAEau', label: 'IAEau' },
    { value: 'Autres', label: 'Autres' },
]

const CATEGORIES_LABELS = values(CATEGORIES_TICKETS)

const STATUS_TICKETS_LABEL = {
    NOUVEAU: 'Nouveau',
    COMMENTAIRE: 'Commentaire',
    EN_COURS: 'En cours',
    REOUVERT: 'Réouvert',
    AFFECTE: 'Affecté',
    ATTENTE_VALIDATION_INTERNE: 'Attente validation interne',
    EN_VALIDATION_INTERNE: 'En validation interne',
    ATTENTE_MISE_EN_PRODUCTION: 'Attente mise en production',
    TRAITE: 'Traité',
    EN_RECETTE: 'En recette',
    FERME: 'Fermé',
}

const STATUS_TICKETS_ID_AND_LABEL = {
    NOUVEAU: 10,
    COMMENTAIRE: 20,
    EN_COURS: 30,
    REOUVERT: 40,
    AFFECTE: 50,
    ATTENTE_VALIDATION_INTERNE: 60,
    EN_VALIDATION_INTERNE: 65,
    ATTENTE_MISE_EN_PRODUCTION: 70,
    TRAITE: 80,
    EN_RECETTE: 85,
    FERME: 90,
    10: STATUS_TICKETS_LABEL.NOUVEAU,
    20: STATUS_TICKETS_LABEL.COMMENTAIRE,
    30: STATUS_TICKETS_LABEL.EN_COURS,
    40: STATUS_TICKETS_LABEL.REOUVERT,
    50: STATUS_TICKETS_LABEL.AFFECTE,
    60: STATUS_TICKETS_LABEL.ATTENTE_VALIDATION_INTERNE,
    65: STATUS_TICKETS_LABEL.EN_VALIDATION_INTERNE,
    70: STATUS_TICKETS_LABEL.ATTENTE_MISE_EN_PRODUCTION,
    80: STATUS_TICKETS_LABEL.TRAITE,
    85: STATUS_TICKETS_LABEL.EN_RECETTE,
    90: STATUS_TICKETS_LABEL.FERME,
}

const STATUS_TICKETS = [
    { color: '#fcbdbd', id: STATUS_TICKETS_ID_AND_LABEL.NOUVEAU, value: STATUS_TICKETS_LABEL.NOUVEAU, sortValue: 1 },
    { color: '#c2dfff', id: STATUS_TICKETS_ID_AND_LABEL.AFFECTE, value: STATUS_TICKETS_LABEL.AFFECTE, sortValue: 2 },
    { color: '#66cacc', id: STATUS_TICKETS_ID_AND_LABEL.EN_COURS, value: STATUS_TICKETS_LABEL.EN_COURS, sortValue: 3 },
    { color: '#e3b7eb', id: STATUS_TICKETS_ID_AND_LABEL.COMMENTAIRE, value: STATUS_TICKETS_LABEL.COMMENTAIRE, sortValue: 4 },
    { color: '#fff494', id: STATUS_TICKETS_ID_AND_LABEL.REOUVERT, value: STATUS_TICKETS_LABEL.REOUVERT, sortValue: 5 },
    { color: '#6676cc', id: STATUS_TICKETS_ID_AND_LABEL.ATTENTE_VALIDATION_INTERNE, value: STATUS_TICKETS_LABEL.ATTENTE_VALIDATION_INTERNE, sortValue: 6 },
    { color: '#e39619', id: STATUS_TICKETS_ID_AND_LABEL.EN_VALIDATION_INTERNE, value: STATUS_TICKETS_LABEL.EN_VALIDATION_INTERNE, sortValue: 7 },
    { color: '#92c55f', id: STATUS_TICKETS_ID_AND_LABEL.ATTENTE_MISE_EN_PRODUCTION, value: STATUS_TICKETS_LABEL.ATTENTE_MISE_EN_PRODUCTION, sortValue: 8 },
    { color: '#bd64a2', id: STATUS_TICKETS_ID_AND_LABEL.EN_RECETTE, value: STATUS_TICKETS_LABEL.EN_RECETTE, sortValue: 9 },
    { color: '#d2f5b0', id: STATUS_TICKETS_ID_AND_LABEL.TRAITE, value: STATUS_TICKETS_LABEL.TRAITE, sortValue: 10 },
    { color: '#c9ccc4', id: STATUS_TICKETS_ID_AND_LABEL.FERME, value: STATUS_TICKETS_LABEL.FERME, sortValue: 11 },
]
const HANDLERS_DEVS = [
    { value: 'amartinrio', label: 'amartinrio' },
    { value: 'agerault', label: 'agerault' },
    { value: 'cgouin', label: 'cgouin' },
    { value: 'jroba', label: 'jroba' },
    { value: 'mmathurin', label: 'mmathurin' },
    { value: 'nakil', label: 'nakil' },
    { value: 'pminot', label: 'pminot' },
    { value: 'raloui', label: 'raloui' },
    { value: 'sbarthon', label: 'sbarthon' },
    { value: 'sgille', label: 'sgille' },
    { value: 'tlaurens', label: 'tlaurens' },
    { value: 'tlucente', label: 'tlucente' },
    { value: 'tpasquet', label: 'tpasquet' },
    { value: 'tplaza', label: 'tplaza' },
    { value: 'ygreco', label: 'ygreco' },
    { value: 'ykaddouri', label: 'ykaddouri' },
]

const DEFAULT_SETTINGS_VIEW = {
    showServsWithoutInstances: true,
    showSaveError: true,
    showDiskSpaceWarning: true,
    showSupervisionWarning: true,
    nbColumns: 7,
    mapColumnsSize: 18,
    hideToastrs: false,
}

export { months, semester, trimester, CATEGORIES_TICKETS, PRODUCT_LIST, CATEGORIES_LABELS,
    STATUS_TICKETS, STATUS_TICKETS_ID_AND_LABEL, STATUS_TICKETS_LABEL, HANDLERS_DEVS,
    URL_WANTED, DEFAULT_SETTINGS_VIEW }